import { LoadIndicator } from 'devextreme-react/load-indicator';

//styles
import '../styles/loading.css'
const Loading = ({isVisble,size, text=null}) => {
  return (
    <div className="loading">
        <LoadIndicator
        visible={isVisble}
        height={size ? size : 40}
        width={size ? size : 40}
          />
          {text &&
              <span className="loading-text">{text}</span>  
          }
    </div> 
  )
}

export default Loading